<script>
	import Logo from '$lib/icons/Logo.svelte'
</script>

<footer class="bg-white">
	<div class="w-full px-6 lg:px-8 lg:max-w-screen-xl mx-auto py-6">
		<div class="md:flex md:justify-between">
			<div class="mb-6 md:mb-0">
				<a href="/" class="flex items-center">
					<div class="w-40 lg:w-52">
						<Logo />
					</div>
				</a>
			</div>
			<div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
				<div>
					<h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase">Resources</h2>
					<ul class="text-gray-500 font-medium">
						<li class="mb-4">
							<a href="/docs" class="hover:underline">Docs</a>
						</li>
						<li class="mb-4">
							<a href="/exchanges" class="hover:underline">Exchanges</a>
						</li>
					</ul>
				</div>
				<div>
					<h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase">Community</h2>
					<ul class="text-gray-500 font-medium">
						<li class="mb-4">
							<a href="https://x.com/Ticker_Data" class="hover:underline">Twitter</a>
						</li>
						<li class="mb-4">
							<a href="https://discord.gg/2zcEtQb93g" class="hover:underline">Discord</a>
						</li>
						<li>
							<a href="https://www.youtube.com/@tickerdata/featured" class="hover:underline">YouTube</a>
						</li>
					</ul>
				</div>
				<div>
					<h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase">Legal</h2>
					<ul class="text-gray-500 font-medium">
						<li class="mb-4">
							<a href="/privacy-policy" class="hover:underline">Privacy Policy</a>
						</li>
						<li>
							<a href="/terms-of-service" class="hover:underline">Terms of Service</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<hr class="my-6 border-gray-200 sm:mx-auto lg:my-8" />
		<div class="sm:flex sm:items-center sm:justify-between">
			<span class="text-sm text-gray-500 sm:text-center"
				>© {new Date().getFullYear()}
				<a href="/" class="hover:underline">Tickerdata™</a>. All Rights Reserved.
			</span>
			<div class="flex mt-4 sm:justify-center sm:mt-0">
				<a href="https://discord.gg/2zcEtQb93g" class="text-gray-500 hover:text-gray-900 ms-5">
					<svg
						class="w-4 h-4"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="currentColor"
						viewBox="0 0 21 16"
					>
						<path
							d="M16.942 1.556a16.3 16.3 0 0 0-4.126-1.3 12.04 12.04 0 0 0-.529 1.1 15.175 15.175 0 0 0-4.573 0 11.585 11.585 0 0 0-.535-1.1 16.274 16.274 0 0 0-4.129 1.3A17.392 17.392 0 0 0 .182 13.218a15.785 15.785 0 0 0 4.963 2.521c.41-.564.773-1.16 1.084-1.785a10.63 10.63 0 0 1-1.706-.83c.143-.106.283-.217.418-.33a11.664 11.664 0 0 0 10.118 0c.137.113.277.224.418.33-.544.328-1.116.606-1.71.832a12.52 12.52 0 0 0 1.084 1.785 16.46 16.46 0 0 0 5.064-2.595 17.286 17.286 0 0 0-2.973-11.59ZM6.678 10.813a1.941 1.941 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.919 1.919 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Zm6.644 0a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.918 1.918 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Z"
						/>
					</svg>
					<span class="sr-only">Discord community</span>
				</a>
				<a href="https://x.com/ticker_data" class="text-gray-500 hover:text-gray-900 ms-5">
					<svg
						class="w-4 h-4"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="currentColor"
						viewBox="0 0 20 17"
					>
						<path
							fill-rule="evenodd"
							d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="sr-only">Twitter page</span>
				</a>
				<a
					href="https://www.youtube.com/@tickerdata/featured"
					class="text-gray-500 hover:text-gray-900 ms-5"
				>
					<svg
						class="w-4 h-4"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="currentColor"
						viewBox="0 0 20 17"
					>
						<path
							fill-rule="evenodd"
							d="M19.7 3.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.84c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.84A4.225 4.225 0 0 0 .3 3.038a30.148 30.148 0 0 0-.2 3.206v1.5c.01 1.071.076 2.142.2 3.206.094.712.363 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.15 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965c.124-1.064.19-2.135.2-3.206V6.243a30.672 30.672 0 0 0-.202-3.206ZM8.008 9.59V3.97l5.4 2.819-5.4 2.8Z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="sr-only">Youtube Channel</span>
				</a>
			</div>
		</div>
	</div>
</footer>
